// "New template" as a page, not a dialog asking only for a name.
//
// Unlike locations and screens, this loses nothing to being pre-creation: the
// preview renders the form's values rather than a saved row, so the whole
// editor — every section and the live iframe — works before the template
// exists. Save posts it and hands over to the detail page.

import { createFileRoute } from "@tanstack/react-router";
import { TemplateCreateEditor } from "@/features/templates/template-editor";

export const Route = createFileRoute("/w/$workspaceId/templates/new")({
    component: NewTemplatePage,
});

function NewTemplatePage() {
    const { workspaceId } = Route.useParams();
    return (
        <div className="flex flex-col gap-6">
            <h1 className="text-xl font-semibold tracking-tight">New template</h1>
            <TemplateCreateEditor workspaceId={workspaceId} />
        </div>
    );
}
